export enum PaymentMethodDefaultName {
  MobilePay = 'MobilePay',
  Stripe = 'Stripe',
}
